module.exports = __webpack_public_path__ + "static/img/pattern_4.96d0f6ef.png";